import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const NAMESPACE = 'cancellation';

export const initialState = {
  billingName: '',
  bookingId: '',
};

const cancellationSlice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    updateReceipt(
      state,
      action: PayloadAction<{
        billingName: string;
      }>
    ) {
      state.billingName = action.payload.billingName;
    },
    clear(state) {
      state.billingName = initialState.billingName;
      state.bookingId = initialState.bookingId;
    },
    setBookingId(state, action: PayloadAction<{ bookingId: string }>) {
      state.bookingId = action.payload.bookingId;
    },
  },
});

export default cancellationSlice;
